/**
 * Eligible zipcodes for VMODCOVP401 (Alaska only - test list)
 * Alaska zipcodes for testing purposes
 * Total zipcodes: 108
 */
export const modcoVP401EligibleZipCodes: readonly string[] = [
  // Anchorage area (995xx)
  "99501", "99502", "99503", "99504", "99505", "99506", "99507", "99508", "99509", "99510",
  "99511", "99513", "99514", "99515", "99516", "99517", "99518", "99519", "99520", "99521",
  "99522", "99523", "99524", "99529", "99530", "99540", "99567", "99587", "99599",

  // Fairbanks area (997xx)
  "99701", "99702", "99703", "99704", "99705", "99706", "99707", "99708", "99709", "99710",
  "99711", "99712", "99714", "99716", "99720", "99721", "99722", "99723", "99724", "99725",
  "99726", "99727", "99729", "99730", "99733", "99737", "99738", "99739", "99740", "99741",
  "99742", "99743", "99744", "99745", "99746", "99747", "99748", "99749", "99750", "99751",
  "99752", "99753", "99754", "99755", "99756", "99757", "99758", "99759", "99760", "99761",
  "99762", "99763", "99764", "99765", "99766", "99767", "99768", "99769", "99770", "99771",
  "99772", "99773", "99774", "99775", "99776", "99777", "99778", "99780", "99781", "99782",
  "99783", "99784", "99785", "99786", "99788", "99789", "99790", "99791",

  // Juneau area (998xx)
  "99801", "99802", "99803", "99811", "99812", "99820", "99821", "99824", "99825", "99826",
  "99827", "99829", "99830", "99832", "99833", "99835", "99836", "99840", "99841",
] as const;
